export default __webpack_public_path__ + "static/media/17.fc95260d.svg";